import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { RequestStation } from "../features/stationRequest/RequestStation";

export function RequestStationRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl px-4 py-6">
      <h1 className="mb-1 text-2xl font-bold text-fg">{t("stations.request.title")}</h1>
      <p className="mb-4 text-sm text-fg-mute">{t("stations.request.subtitle")}</p>
      <RequestStation onSuccess={() => setTimeout(() => navigate("/"), 1500)} />
    </div>
  );
}
